import { useContext } from "react";
import { GlobalModuleTabsContext } from "src/App/GlobalModuleTabsContext";

export const useGlobalModuleTabs = () => {
  const context = useContext(GlobalModuleTabsContext);
  if (!context) {
    throw new Error(
      "useGlobalModuleTabs must be used inside a GlobalModuleTabsProvider",
    );
  }
  return context;
};
